export default __webpack_public_path__ + "static/media/white_close.792e386b.svg";